<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑工序' : '新增工序'"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <div class="group-title m-b-10">基本信息</div>
          <e-form ref="refForm1" :column="formColumn1" :data.sync="selfData" />
          <div class="group-title m-b-10 m-t-20">工时信息</div>
          <e-form ref="refForm2" :column="formColumn2" :data.sync="selfData" />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        id: '',
        code: '',
        name: '',
        lei_xing: '',
        fen_zu: '',
        miao_shu: '',
        tu_zhi_list: [],
        fu_jian_list: [],
        status: true,

        biao_zhun_gong_shi: '',
        fu_zhu_gong_shi: '',
        gong_xu_dan_wei: '',
        gong_xu_cheng_ben: ''
      },
      formColumn1: [
        {
          type: 'text',
          title: '工序编码',
          field: 'code',
          disabled: true,
          placeholder: '自动生成'
        },
        {
          type: 'text',
          title: '工序名称',
          field: 'name'
        },
        {
          type: 'select',
          title: '工序类型',
          field: 'lei_xing',
          options: [
            {
              key: '自制工序',
              val: '自制工序'
            },
            {
              key: '委外工序',
              val: '委外工序'
            }
          ]
        },
        {
          type: 'select',
          title: '工序分组',
          field: 'fen_zu',
          options: []
        },
        {
          type: 'textarea',
          title: '工序描述',
          field: 'miao_shu',
          width: '100%'
        },
        {
          type: 'upload_image',
          title: '工序图纸',
          field: 'tu_zhi_list'
        },
        {
          type: 'upload_file',
          title: '附件文档',
          field: 'fu_jian_list',
          isDelete: true
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      formColumn2: [
        {
          type: 'number',
          title: '标准工时',
          field: 'biao_zhun_gong_shi',
          suffix: '分钟'
        },
        {
          type: 'number',
          title: '辅助工时',
          field: 'fu_zhu_gong_shi',
          suffix: '分钟'
        },
        {
          type: 'text',
          title: '工序单位',
          field: 'gong_xu_dan_wei'
        },
        {
          type: 'number',
          title: '工序成本',
          field: 'gong_xu_cheng_ben',
          suffix: '元'
        }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getGroupistData()
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.initSelfData()
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/gongxu/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 初始化数据
    initSelfData() {
      this.loaded = false
      this.loaded = true
    },
    // 获取数据列表
    getGroupistData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/list',
        data: {
          type: '工序',
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.list.map((item) => {
              return {
                key: item.name,
                val: item.name
              }
            })
            this.formColumn1.forEach((item) => {
              if (item.field === 'fen_zu') {
                item.options = result
              }
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongxu/saveOrUpdate',
        data: {
          form_data: this.$util.deepCopy(this.selfData)
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
